// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"193":"17897898","217":"0a9f012f","264":"17897898","400":"a925ce8a","467":"17897898","661":"17897898","851":"17897898","987":"17897898"}[chunkId] + ".chunk.css";
};